// Error components must be Client Components
"use client";

import {useEffect} from "react";

export default function Error({error, reset}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <section className="hero is-medium is-danger">
      <div className="hero-body has-text-centered">
        <p className="subtitle is-size-1">Something went wrong!</p>
        <button className="button is-warning" onClick={() => reset()}>
          Try again
        </button>
      </div>
    </section>
  );
}
